import { create } from 'zustand'

// Help entries open the guide drawer through this store, so they never import the host.
interface TutorialUiState {
  drawerOpen: boolean
  /** The element focus returns to when the drawer or card closes. */
  invoker: HTMLElement | null
  openDrawer: (invoker?: HTMLElement | null) => void
  closeDrawer: () => void
}

export const useTutorialUi = create<TutorialUiState>()((set) => ({
  drawerOpen: false,
  invoker: null,
  openDrawer: (invoker) => set({ drawerOpen: true, invoker: invoker ?? (document.activeElement as HTMLElement | null) }),
  closeDrawer: () => set({ drawerOpen: false }),
}))

export function openTutorialDrawer(invoker?: HTMLElement | null): void {
  useTutorialUi.getState().openDrawer(invoker)
}
